var CARD_LEADING_MINIMAL_WIDTH = 328;
var MAX_PER_PAGE = 3;
export var calculateAmountOfItemsPerPage = function calculateAmountOfItemsPerPage(wrapperWidth) {
  var amount = Math.floor(wrapperWidth / CARD_LEADING_MINIMAL_WIDTH);
  if (amount < 1) {
    return 1;
  }
  return amount > MAX_PER_PAGE ? MAX_PER_PAGE : amount;
};